module.exports = __webpack_public_path__ + "img/calculator.1ae539c5.svg";